import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { FormationComponent } from './formation.component';
import { FormationsComponent } from './formations.component';

const routes: Routes = [
  {
    path: '',
    component: FormationsComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component:FormationComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormationsRoutingModule { }

export const routedComponents = [
  FormationsComponent,
  FormationComponent
];
